var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded-of",class:_vm.buttonclass,attrs:{"height":_vm.height,"block":_vm.block,"icon":_vm.icon,"text":_vm.text,"depressed":"","disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }